import { ChangeEvent, useContext, useState } from 'react'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import { CenterModalContext } from '@src/contexts/popup/modal/CenterModalProvider'

import { TestFormType } from './types'
import { compressImage, resizeImage } from '@src/utils/image'

type PropsType = {
	handleCompressImage: (
		e: React.ChangeEvent<HTMLInputElement>,
		destField: keyof TestFormType,
	) => void
	compressedFile: Blob
}

const ContextTest = ({ handleCompressImage, compressedFile }: PropsType) => {
	const { register, setValue } = useFormContext<TestFormType>()
	const { openCenterModal, closeCenterModal } = useContext(CenterModalContext)

	const [compImg, setCompImg] = useState<Blob>()
	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const reader = new FileReader()

		reader.onload = async (evt) => {
			try {
				const result = evt.target?.result
				console.log(result)
				if (result) {
					const temp = await resizeImage(result.toString(), 860, Infinity)

					const resizedImg =
						temp.size > 3000000
							? await compressImage(temp, {
									maxSizeMB: 3,
									maxWidthOrHeight: Infinity,
									alwaysKeepResolution: true,
							  })
							: temp

					setCompImg(resizedImg)
				}
			} catch (error) {
				console.log(error)
				openCenterModal({ desc: '이미지의 크기가 너 큽니다' }, closeCenterModal)
			}
		}
		const { files } = e.target
		if (files) {
			reader.readAsDataURL(files[0])
		}
	}

	return (
		<div>
			<input
				type="file"
				{...register('file', {
					onChange: handleChange,
				})}
				accept="image/jpeg, image/png"
			/>
			{compImg && (
				<ImageBlock>
					<img src={URL.createObjectURL(compImg)} alt="compressed file" />
				</ImageBlock>
			)}
		</div>
	)
}

const ImageBlock = styled.div`
	width: 37.5rem;
	img {
		width: 100%;
		object-fit: cover;
	}
`

export default ContextTest
